import React from 'react'
import { TextArea } from 'grommet'
import { ThemeContext } from 'styled-components'

const TallTextArea = ({ height, lineHeight = '24px', ...restProps }) => {
  return (
    <ThemeContext.Extend
      value={{
        textArea: {
          extend: {
            height: height,
            lineHeight: lineHeight
          }
        }
      }}>
      <TextArea {...restProps} />
    </ThemeContext.Extend>
  )
}

export default TallTextArea
